import { lazy } from "react";
import { GraficoOuTabela, type Coluna } from "@/components/financeiro/visao/GraficoOuTabela";
import { atrasoMedio, estouroMedio, fracao, horas, pct, type SalaDaOcupacao } from "./formato";

const GraficoPorSala = lazy(() => import("./grafico-por-sala").then((m) => ({ default: m.GraficoPorSala })));

const COLUNAS: Coluna<SalaDaOcupacao>[] = [
  { titulo: "Sala", valor: (s) => s.nome },
  { titulo: "Agendado", valor: (s) => pct(fracao(s.agendadoMin, s.expedienteMin)), numero: true },
  { titulo: "Uso real", valor: (s) => pct(fracao(s.realMin, s.realPossivelMin)), numero: true },
  { titulo: "Livre", valor: (s) => horas(s.livreMin), numero: true },
  { titulo: "Consultas", valor: (s) => s.consultas, numero: true },
  { titulo: "Atraso médio", valor: (s) => (atrasoMedio(s) === null ? "—" : `${atrasoMedio(s)} min`), numero: true },
  { titulo: "Passou do horário", valor: (s) => (s.estouros.length ? `${s.estouros.length} (${estouroMedio(s)} min)` : "0"), numero: true },
  { titulo: "Faltas", valor: (s) => s.faltas, numero: true },
  { titulo: "Sem encerramento", valor: (s) => s.semEncerramento, numero: true },
];

/** Agendado contra uso real, sala a sala; a tabela traz atrasos, faltas e o que ficou livre. */
export function OcupacaoPorSala({ salas, competencia }: { salas: SalaDaOcupacao[]; competencia: string }) {
  const dados = salas.map((s) => ({ nome: s.nome, agendado: fracao(s.agendadoMin, s.expedienteMin), real: fracao(s.realMin, s.realPossivelMin) }));
  return (
    <GraficoOuTabela
      titulo="Por sala"
      descricao="Agendado: parte do expediente do mês com consulta. Uso real: do início ao fim do atendimento, nos dias até hoje."
      colunas={COLUNAS}
      linhas={salas}
      nomeDoArquivo={`ocupacao-das-salas-${competencia}`}
      vazio="Sem salas neste mês."
    >
      <GraficoPorSala dados={dados} />
    </GraficoOuTabela>
  );
}
